<template>
    <v-dialog v-model="dialog" persistent width="400">
        <div
            class="d-flex flex-column justify-center align-center elevation-15 higlight-type-content"
        >
            <div
                class="higlight-type-content d-flex flex-column justify-center align-center position-relative pa-10"
            >
                <v-btn color="primary" icon class="position-absolute btn-cls" @click="close">
                    <v-icon color="primary">mdi-close-circle</v-icon>
                </v-btn>
                <div class="h-type-img w-100 d-flex flex-row justify-start align-center">
                    <img :src="markierImg" alt="icono de marcador" />
                    <span class="primary--text font-size-24">{{ $t('bookReading.marker') }}:</span>
                </div>
                <div class="h-type-img w-100 mt-2 d-flex flex-row justify-start align-center">
                    <span class="primary--text text-justify text-body-1"
                        >{{ $t('bookReading.highlight_modal_msg') }}:</span
                    >
                </div>
                <div class="py-3 d-flex flex-column justify-center align-center">
                    <v-row class="w-75">
                        <v-col
                            cols="6"
                            v-for="(highlightType, index) of highlightTypes"
                            :key="index"
                        >
                            <div
                                :data-cy="`HighlightTypeSelect-${highlightType.value}-button`"
                                :class="
                                    'd-flex flex-column justify-center align-center pa-3 border-radius-1 h-type elevation-4 transition-all ' +
                                    (highlightType.id === typeSelected ? 'active' : '')
                                "
                                :id="`h-type-${highlightType.id}`"
                                @click="setSelectedType(highlightType.id)"
                            >
                                <img :src="highlightType.img" alt="icono de marcador" />
                                <span>{{ highlightType.value }}</span>
                            </div>
                        </v-col>
                    </v-row>
                </div>
                <v-card-actions class="d-flex justify-center align-center">
                    <v-spacer></v-spacer>
                    <v-btn
                        data-cy="HighlightTypeSelect-save-button"
                        color="secondary"
                        class="px-16 py-5"
                        rounded
                        :loading="btnLoaded"
                        @click="saveMarker"
                    >
                        {{ $t('save') }}
                    </v-btn>
                </v-card-actions>
            </div>
        </div>
    </v-dialog>
</template>
<script>
/* eslint-disable global-require */

export default {
    props: {
        dialog: { type: Boolean, default: false },
    },
    data() {
        return {
            typeSelected: null,
            btnLoaded: false,
            markierImg: require('@/assets/img/icons/reading/icon-highlightings-2.svg'),
            highlightTypes: [
                {
                    id: 0,
                    value: this.$t('bookReading.characters'),
                    color: '#97ed57',
                    img: require('@/assets/img/icons/reading/highlight/icon-personajes.svg'),
                },
                {
                    id: 1,
                    value: this.$t('bookReading.actions'),
                    color: '#57d6ed',
                    img: require('@/assets/img/icons/reading/highlight/icon-acciones.svg'),
                },
                {
                    id: 2,
                    value: this.$t('bookReading.vocabulary'),
                    color: '#ffdb39',
                    img: require('@/assets/img/icons/reading/highlight/icon-vocabulario.svg'),
                },
                {
                    id: 3,
                    value: this.$t('bookReading.places'),
                    color: '#ff44b9',
                    img: require('@/assets/img/icons/reading/highlight/icon-lugares.svg'),
                },
            ],
        }
    },
    methods: {
        close() {
            this.$emit('close-modal')
        },
        saveMarker() {
            this.$emit('save-highlight')
        },
        setSelectedType(id) {
            this.typeSelected = id
        },
        resetVars() {
            this.typeSelected = null
            this.btnLoaded = false
        },
    },
}
</script>
<style>
.h-type-img {
    z-index: 300;
}
.h-type-img img {
    height: 5vh;
    z-index: 10;
}
.higlight-type-content {
    border-radius: 26px;
    background: #e2f3f2;
}
.h-type {
    background: white;
    border: 1.5px solid #514773 !important;
}

.h-type:hover {
    background: rgb(216, 216, 216);
    cursor: pointer;
}

.h-type.active {
    border: 3px solid #514773 !important;
}

.btn-cls {
    top: 1vh;
    right: 1vh;
    z-index:10;
}
</style>
